import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { BqButton, BqIcon } from '@beeq/react'
import { StyledBqDialog, StyledTitle, StyledWrapper, StyledDialogBqButton } from './styles'
import { epagAPI } from '../../../../API/epagAPI'
import { Text } from '../../../../constants/TextConstants'
import { useGetToken } from '../../../../hooks/useGetToken'
import { useNavigate } from 'react-router-dom'

export const ConfirmProfileDeletionDialog = ({ userEmail, toggleDeleteModalOpen, isOpenDeleteModal, setIsLoading, getProfiles, filtersToRequest, advancedSearchFilterData }) => {
  const navigate = useNavigate()
  const { token } = useGetToken()

  const [isDeleting, setIsDeleting] = useState(false)

  const deleteProfileHandler = useCallback(async () => {
    setIsDeleting(true)
    const response = await epagAPI.DeleteProfile(userEmail, token)
    if (response.deletedCount > 0 && response.ok === 1) {
      setIsLoading(true)
      getProfiles(filtersToRequest(advancedSearchFilterData)) // reloads only the profiles
    }
    setIsDeleting(false)
    toggleDeleteModalOpen()
  }, [navigate, userEmail, token, epagAPI, toggleDeleteModalOpen])

  return (
    <StyledBqDialog
      open={isOpenDeleteModal}
      size='large'
      onBqClose={toggleDeleteModalOpen}
      onBqCancel={toggleDeleteModalOpen}
      data-testid='delete-dialog'>
      <StyledTitle slot='title' data-testid='delete-dialog-title'>
        <BqIcon name='info' size={31} weight='bold'></BqIcon>
        {Text.DeleteModalTitle}
      </StyledTitle>

      <p data-testid='delete-dialog-description'>{Text.DeleteModalDescription}</p>
      <StyledWrapper slot='footer'>
        <StyledDialogBqButton
          appearance='text'
          onBqClick={toggleDeleteModalOpen}
          data-testid='delete-dialog-cancel-btn'>
          {Text.Cancel}
        </StyledDialogBqButton>

        <BqButton onBqClick={deleteProfileHandler} loading={isDeleting} data-testid='delete-dialog-delete-btn'>
          {Text.Delete}
        </BqButton>
      </StyledWrapper>
    </StyledBqDialog>
  )
}

ConfirmProfileDeletionDialog.propTypes = {
  userEmail: PropTypes.string.isRequired,
  toggleDeleteModalOpen: PropTypes.func.isRequired,
  isOpenDeleteModal: PropTypes.bool.isRequired,
  setIsLoading: PropTypes.func,
  getProfiles: PropTypes.func,
  filtersToRequest: PropTypes.func,
  advancedSearchFilterData: PropTypes.object
}
